import Vue from 'vue'
import Vuex from 'vuex'
import SharedPlugin from '../utils/SharedPlugin'
import ContextPlugin, { CONTEXT } from './helpers/contextPlugin'

import {
  SET_FILTERS,
  SET_PARAMS,
  SET_PRODUCTS,
  SET_PAGINATION,
  SET_NO_PRODUCTS_BLOCK,
  SET_OPTIONS,
  SET_CATEGORY,
  SET_FILTERS_ACTIVE,
  SET_QUERY_STEP,
  SET_QUERY_STRING,
  SET_CATEGORY_FAQ,
  SET_CATEGORY_DESCR, SET_REDIRECT_TO_PAGE
} from './store/mutation-types'
import catalogStore from './store'
import App from './Catalog.vue'
import { getURLFilters, getURLParams } from './helpers/uri'

Vue.config.productionTip = false

Vue.config.errorHandler = function (err, vm, info) {
    // override default error handler to log errors returned by Node
    if (typeof process !== 'undefined') {
        dispatch('<script type=\"text/javascript\"> console.error(\"An Vue SSR error occured\");</script>');

        if (process.env.MAGE_IS_DEVELOPER_MODE) {
            var serializedError = JSON.stringify(err, Object.getOwnPropertyNames(err)).split('\\n').join('<br>');
            dispatch("<pre style='border: solid 1px red;'>Error: " + serializedError + "</pre>");
        }
    }
}

function initCatalog() {
    try {
        Vue.use(ContextPlugin)
        Vue.use(SharedPlugin, {
            axios: {
                baseURL: CONTEXT.apiURL,
                autoSuggestHeader: CONTEXT.options.httpAccept
            }
        })
        Vue.use(Vuex)
    } catch (err) {
        console.log(err)
    }

    return new Vue({
        name: 'Catalog',
        store: catalogStore,
        created() {
            this.hydrateData()
        },
        async serverPrefetch() {
            try {
                if (this.$context.userPharmacy) {
                    this.addUserPharmacyHeader(this.$context.userPharmacy)
                }

                const contextData = await this.$store.dispatch('getProducts')
                if (contextData.products || contextData.filters) {
                    Object.assign(this.$context, contextData)
                }
            } catch (err) {
                console.log(err)
            }
        },
        methods: {
            hydrateData() {
                try {
                    this.$store.commit(SET_CATEGORY, this.$context.category)
                    this.$store.commit(SET_QUERY_STEP, this.$context.query_step)
                    this.$store.commit(SET_QUERY_STRING, this.$context.query_string)
                    this.$store.commit(SET_CATEGORY_FAQ, this.$context.faq)
                    this.$store.commit(SET_CATEGORY_DESCR, this.$context.category_description)
                    this.$store.commit(SET_OPTIONS, this.$context.options)
                    this.$store.commit(SET_FILTERS, this.$context.filters)
                    this.$store.commit(
                        SET_FILTERS_ACTIVE,
                        getURLFilters(this.$context.queryParams)
                    )
                    this.$store.commit(SET_PAGINATION, this.$context.pagination)
                    this.$store.commit(SET_NO_PRODUCTS_BLOCK, this.$context.no_products_block)
                    this.$store.commit(
                        SET_PARAMS,
                        getURLParams(this.$context.params)
                    )
                    this.$store.commit(SET_REDIRECT_TO_PAGE, this.$context.redirect_to_page)

                    this.$store.commit(SET_PRODUCTS, this.$context.products)
                    if (this.$http.defaults.headers.common['Cookie']) {
                        delete this.$http.defaults.headers.common.Cookie
                    }
                } catch (err) {
                    console.log(err)
                }
            },
            addUserPharmacyHeader(userPharmacy) {
                // pass userPharmacy cookie to Node
                // because Node is not able to use request object
                this.$http.defaults.headers.common[
                    'Cookie'
                ] = `userPharmacy=${encodeURIComponent(
                    JSON.stringify(userPharmacy)
                )}; SameSite=None; Secure;`
            }
        },
        render(h) {
            return h(App)
        }
    }).$mount('#catalog-vue')
}

export default initCatalog
